import './index.scss';

import 'plyr/dist/plyr.css';
import 'rc-slider/assets/index.css';
import 'react-toastify/dist/ReactToastify.css';
import 'swagger-ui/dist/swagger-ui.css';

import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { ToastContainer } from 'react-toastify';
import store from 'store/index';
import App from './App';

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            refetchOnWindowFocus: false,
            retry: 2,
            // cacheTime: 0,
        },
    },
});

window.addEventListener('vite:preloadError', function () {
    const reloadKey = 'chunk_reload_attempt';
    if (!sessionStorage.getItem(reloadKey)) {
        sessionStorage.setItem(reloadKey, '1');
        window.location.reload();
    } else {
        sessionStorage.removeItem(reloadKey);
        console.log('Failed to load the page. Please check your connection.');
    }
});

createRoot(document.getElementById('root')!).render(
    // <StrictMode>
    <Provider store={store}>
        <QueryClientProvider client={queryClient}>
            <App />

            <ToastContainer autoClose={3000} hideProgressBar={true} position="top-center" />
        </QueryClientProvider>
    </Provider>
    // </StrictMode>,
);
